import { LoadingState } from 'Components/LoadingState/LoadingState'

export const InfiniteScrollLoadingState = () => (
  <LoadingState height={50} margin={100} />
)
